import * as React from 'react';
import { css } from 'aphrodite';
import { a11y } from '@blend/consumer-components';
import { getIdFromName } from 'login-components/Common/Inputs/inputUtils';
import ErrorMessage from 'login-components/Common/Notifications/ErrorMessage/ErrorMessage';
import { BlIcon, BlIconType } from '@blend/shared-react';
import * as inputUtils from '../inputUtils';
import './input-container.scss';
type StatusType = 'match' | 'mismatch';

export interface InputContainerProps {
  icon?: BlIconType;
  error?: string;
  status?: StatusType | null;
  active?: boolean;
  label?: string;
  identifier: string;
  name: string;
  prefix?: string | null;
}

function getIconFromStatus(status: StatusType): BlIconType {
  switch (status) {
    case 'match':
      return 'success';
    case 'mismatch':
      return 'error';
    /* istanbul ignore next: (UI-5482) */
    default:
      throw new Error(`Unmatched input status: ${status}`);
  }
}

class InputContainer extends React.Component<InputContainerProps, {}> {
  render() {
    const { icon, status, error, name, active, prefix, label, identifier, children } = this.props;
    const ariaErrorDescriptor = inputUtils.getErrorDescriptor(name, !!error);
    const htmlId = getIdFromName(name);
    if (icon && prefix) {
      throw new Error('Icon and prefix props are mutually exclusive.');
    }

    return (
      <div
        className={`Input Input--${icon || prefix ? 'with' : 'without'}Icon Input--${error ? 'with' : 'without'}Error`}
      >
        {label ? (
          <label htmlFor={htmlId} className="Input-label">
            {label}
          </label>
        ) : (
          <label className={css(a11y.srOnly)} htmlFor={htmlId}>
            {identifier}
          </label>
        )}
        <div className="Input-indicatorWrapper">
          {!!(icon || prefix) && (
            <div className="Input-iconWrapper">
              {icon && <BlIcon icon={icon} />}
              {prefix && <span className="Input-prefixWrapper">{prefix}</span>}
            </div>
          )}
          {children}
          {status && (
            <div className={`Input-statusWrapper is-${status} is-${active ? 'active' : 'inactive'}`}>
              <BlIcon icon={getIconFromStatus(status)} />
            </div>
          )}
        </div>
        {error && (
          <div className="Input-errorWrapper" id={ariaErrorDescriptor}>
            <ErrorMessage errorText={error} />
          </div>
        )}
      </div>
    );
  }
}

export default InputContainer;
